import { useEffect } from 'react';

export default function LinkedInRedirect() {
  useEffect(() => {
    window.location.replace(
      'https://www.linkedin.com/in/jonathan-n-35068042b'
    );
  }, []);

  return null;
};
